module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classList
  }, [_c('div', {
    staticClass: "reveal-wrap",
    attrs: {
      "data-aos": "reveal",
      "data-aos-duration": "1200"
    }
  }, [_c('div', {
    staticClass: "reveal-block"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('../../assets/images/' + _vm.imageSrc)
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reveal-wrap reveal-shadow",
    attrs: {
      "data-aos": "reveal",
      "data-aos-duration": "1200"
    }
  }, [_c('div', {
    staticClass: "reveal-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow-block"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ec0cdfe","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RevealBlock.vue
// module id = 74
// module chunks = 0